import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/components/AuthProvider';
import { 
  getInstructorProfile, 
  updateInstructorProfile, 
  uploadInstructorProfilePicture 
} from '../../api/instructors';
import { InstructorProfileUpdate } from '../types';

export const useInstructorProfile = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['instructor-profile', user?.id],
    queryFn: () => getInstructorProfile(),
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useUpdateInstructorProfile = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (data: InstructorProfileUpdate) => updateInstructorProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['instructor-profile', user?.id] });
    },
  });
};

export const useUploadInstructorProfilePicture = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: ({ instructorId, file }: { instructorId: number; file: File }) => uploadInstructorProfilePicture(instructorId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['instructor-profile', user?.id] });
    },
  });
};
